<section class="benefits">
    <div class="section-title">
      <h2>Herbal products are always the best, why?</h2>
    </div>

    <div class="benefits-grid">
      <div class="benefit-card">
        <div class="benefit-icon">
          <img src="assets/images/cost-icon.png" alt="Affordable">
        </div>
        <h3>More affordable than conventional medicine</h3>
      </div>

      <div class="benefit-card">
        <div class="benefit-icon">
          <img src="assets/images/availability-icon.png" alt="Easy availability">
        </div>
        <h3>Easy availability</h3>
      </div>

      <div class="benefit-card">
        <div class="benefit-icon">
          <img src="assets/images/hormones-icon.png" alt="Stabilizes hormones">
        </div>
        <h3>Stabilizes hormones and your metabolism</h3>
      </div>

      <div class="benefit-card">
        <div class="benefit-icon">
          <img src="assets/images/healing-icon.png" alt="Natural healing">
        </div>
        <h3>Natural healing</h3>
      </div>
    </div>
</section>
